import { createContext, useContextSelector } from '@fluentui/react-context-selector';
export const listContextDefaultValue = {
    navigationMode: undefined,
    selection: undefined,
    listItemRole: 'listitem',
    validateListItem: ()=>{
    /* noop */ }
};
const listContext = createContext(undefined);
export const ListContextProvider = listContext.Provider;
export const useListContext_unstable = (selector)=>useContextSelector(listContext, (ctx = listContextDefaultValue)=>selector(ctx));
